module.exports = __webpack_public_path__ + "img/oni-mansion-banner-frame-gif.e39da0b3.gif";